export const nameSearchFilter = {
  type: 'search',
  param: 'name',
  label: 'Name',
} as const;
